import { render, staticRenderFns } from "./PageActions.vue?vue&type=template&id=42714f55&scoped=true"
import script from "./PageActions.vue?vue&type=script&lang=js"
export * from "./PageActions.vue?vue&type=script&lang=js"
import style0 from "./PageActions.vue?vue&type=style&index=0&id=42714f55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42714f55",
  null
  
)

export default component.exports